import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const WhyWatrly = () => {
  const { t } = useLanguage();

  const icons = [
    (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
      </svg>
    ),
    (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
    (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
    (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
      </svg>
    ),
    (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
      </svg>
    ),
  ];

  return (
    <section id="why-watrly" className="section-padding bg-gradient-to-b from-watrly-cream via-white to-watrly-sand-light/50 relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-watrly-sand-warm/20 to-transparent" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-watrly-turquoise/8 rounded-full blur-3xl" />
        <div className="absolute top-1/3 right-1/4 w-64 h-64 bg-watrly-desert/10 rounded-full blur-3xl" />
      </div>

      <div className="container-watrly relative">
        {/* Mobile: Image as background with 2-column cards */}
        <div className="lg:hidden relative">
          {/* Background Image */}
          <div className="absolute inset-0 -mx-6 overflow-hidden opacity-15">
            <img
              src="/assets/images/watlry-shibe.png"
              alt="Watrly water filling station"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-watrly-cream via-white/95 to-watrly-sand-light" />
          </div>
          
          {/* Content */}
          <div className="relative">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="text-center mb-6"
            >
              <span className="inline-block text-xs font-semibold text-watrly-turquoise uppercase tracking-widest mb-2">
                {t.whyWatrly.badge}
              </span>
              <h2 className="heading-section mb-2">
                {t.whyWatrly.title}
              </h2>
              <p className="text-sm text-watrly-slate/70 leading-relaxed">
                {t.whyWatrly.subtitle}
              </p>
            </motion.div>

            {/* 2-column grid for cards on mobile */}
            <div className="grid grid-cols-2 gap-3">
              {t.whyWatrly.features.map((feature, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.05 }}
                  className="p-3 rounded-xl bg-white/80 backdrop-blur-sm border border-watrly-slate/10"
                >
                  <div className="w-8 h-8 rounded-lg bg-watrly-turquoise/10 flex items-center justify-center text-watrly-turquoise mb-2">
                    {icons[index]}
                  </div>
                  <h3 className="text-sm font-semibold text-watrly-slate mb-1">
                    {feature.title}
                  </h3>
                  <p className="text-xs text-watrly-slate/60 leading-relaxed line-clamp-2">
                    {feature.description}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>

        {/* Desktop: Original 2-column layout */}
        <div className="hidden lg:grid lg:grid-cols-2 gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6 }}
            className="lg:sticky lg:top-32"
          >
            <span className="inline-block text-sm font-semibold text-watrly-turquoise uppercase tracking-widest mb-4">
              {t.whyWatrly.badge}
            </span>
            <h2 className="heading-section mb-6">
              {t.whyWatrly.title}
            </h2>
            <p className="text-body-lg mb-8">
              {t.whyWatrly.subtitle}
            </p>

            <div className="relative rounded-3xl overflow-hidden">
              <img
                src="/assets/images/watlry-shibe.png"
                alt="Watrly water filling station"
                className="w-full h-auto"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-watrly-slate/60 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <span className="text-white/70 text-sm font-medium">{t.whyWatrly.stationNetwork}</span>
                <p className="text-white text-lg font-semibold mt-1">{t.whyWatrly.stationDesc}</p>
              </div>
            </div>
          </motion.div>

          <div className="space-y-6">
            {t.whyWatrly.features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: '-50px' }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group relative p-6 rounded-2xl bg-watrly-sand-light/50 border border-transparent hover:border-watrly-turquoise/20 hover:bg-white transition-all duration-300 hover:shadow-lg hover:shadow-watrly-turquoise/5"
              >
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-watrly-turquoise/10 flex items-center justify-center text-watrly-turquoise group-hover:bg-watrly-turquoise group-hover:text-white transition-all duration-300">
                    {icons[index]}
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-watrly-slate mb-2">
                      {feature.title}
                    </h3>
                    <p className="text-base text-watrly-slate/60 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyWatrly;
